<template lang="pug">
  main#main.manager-firmwares
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-microchip')
      section.l-section
        .l-section-h
          router-view
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'manager-firmwares',
  components: {
    WcBreadcrumb,
  },
}
</script>
